import { supabase } from '../lib/supabase';

export const fetchClients = async () => {
  const { data, error } = await supabase.from('clients').select('*').order('name', { ascending: true });
  if (error) throw error;
  return data || [];
};

export const fetchBookingsForClients = async (limit = 500) => {
  const { data } = await supabase
    .from('bookings').select('*').order('booking_date', { ascending: false }).limit(limit);
  return data || [];
};

export const insertClient = async (payload) => {
  const { error } = await supabase.from('clients').insert([payload]);
  if (error) throw error;
};

export const updateClient = async (id, payload) => {
  const { error } = await supabase.from('clients').update(payload).eq('id', id);
  if (error) throw error;
};

export const deleteClient = async (id) => {
  const { error } = await supabase.from('clients').delete().eq('id', id);
  if (error) throw error;
};

// 예약 생성 시 클라이언트 자동 등록 — 이미 존재하면 무시 (23505)
export const upsertClientFromBooking = async ({ name, phone, email }) => {
  if (!email) return;
  const { error } = await supabase.from('clients').insert([{ name, phone, email }]);
  if (error && error.code !== '23505') {
    console.warn('Client auto-register failed:', error.message);
  }
};

export const incrementClientNoShow = async (clientName, clientPhone) => {
  try {
    const { data: client } = await supabase.from('clients')
      .select('id, no_show_count').eq('name', clientName).eq('phone', clientPhone).single();
    if (client) {
      await supabase.from('clients').update({
        no_show_count: (client.no_show_count || 0) + 1,
        last_no_show_date: new Date().toISOString(),
      }).eq('id', client.id);
    }
  } catch {}
};
